import React from 'react';
import moment from 'moment-jalaali';
import PatientShow from 'Screens/Home/SystemPatient/components/PatientShow';
import GetAppointmentStatus from 'Utils/Helpers/AppointmentStatus';
import * as icons from 'react-bootstrap-icons';
import LogStatusHistory from './LogStatusHistory';

export default function LogItem({ item }) {
    const { id, user, patient, statusList, lastDate, newDate, deleted,
        lastType, newType, lastStatusLocalId, newStatusLocalId, created_at } = item;
    return (
        <>
            {
                patient &&
                <div className='log-item'>
                    { deleted && <div className='deleted'>{'حذف شده'}</div> }
                    <div className='patient-detail'>
                        <PatientShow
                            name={patient.name}
                            nCode={patient.nCode}
                            mobile={patient.mobile}
                            uniCode={patient.uniCode}
                        />
                        <span className='mx-3 text-secondary'>|</span>
                        <LogStatusHistory key={`app_his_log_${id}`} data={statusList} patient={patient.name} />
                    </div>
                    <div className='changes'>
                        {
                            lastDate !== newDate && 
                            <div key={`change-date-${id}`} className='inner-changes'>
                                <span><icons.Calendar3 /></span>
                                <strong>{lastDate}</strong>
                                <span><icons.CaretLeft /></span>
                                <strong>{newDate}</strong>
                            </div>
                        }
                        {
                            lastType.name !== newType.name &&
                            <div key={`change-type-${id}`} className='inner-changes'>
                                <span><icons.Fingerprint /></span>
                                <strong style={{color: lastType.color}}>{lastType.name}</strong>
                                <span><icons.CaretLeft /></span>
                                <strong style={{color: newType.color}}>{newType.name}</strong>
                            </div>
                        }
                        {
                            lastStatusLocalId !== newStatusLocalId && 
                            <div key={`change-status-${id}`} className='inner-changes'>
                                <span><icons.ArrowLeftRight /></span>
                                <GetAppointmentStatus id={lastStatusLocalId}/>
                                <span><icons.CaretLeft /></span>
                                <GetAppointmentStatus id={newStatusLocalId}/>
                            </div>
                        }
                        <div key={`change-date-${id}`} className='inner-changes'>
                            <span><icons.Person size={18} /></span>
                            <span>{user}</span>
                            <span>|</span>
                            <span><icons.Stopwatch /></span>
                            <span>{moment(created_at).locale('fa').format('dddd')}</span>
                            <span>-</span>
                            <span>{moment(created_at).locale('fa').format('jYYYY/jMM/jDD')}</span>
                            <span>-</span>
                            <span>{moment(created_at).locale('fa').format('HH:mm:ss')}</span>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}